import { ApiError } from '@clockwise/shared';

/**
 * What a picker's dropdown says when its list could not be loaded.
 *
 * A fetch that fails leaves a picker with no rows, and "No matches" is then a
 * lie: it reads as an empty catalog, and the user goes looking for a role or a
 * customer that exists and that they simply may not list (G15). Pass
 * `useEntityAutocomplete`'s `error` here from `renderEmpty`.
 *
 * A refusal is told apart from a failure because the next step differs — one
 * is an access request, the other is trying again.
 */
export function PickerLoadError({
  error,
  noun,
}: {
  /** `error` straight off `useEntityAutocomplete`. */
  error: unknown;
  /** Plural entity noun, e.g. "service roles". */
  noun: string;
}) {
  return (
    <span role="alert" className="text-destructive">
      Couldn’t load {noun}.{' '}
      {error instanceof ApiError && error.code === 'FORBIDDEN'
        ? `You don’t have permission to list ${noun}.`
        : error instanceof ApiError
          ? error.message
          : 'Please try again.'}
    </span>
  );
}
